export default class CookiesView {
    private static url_accept       = '/panel/?action=rodo-accept';
    private static url_accept_body  = '/panel/?action=rodo-accept-body';

    public static init(): void {
        $(() => {
            let $accept = $('.cmstext .accept');

            $accept.click((e) => {
                e.preventDefault();

                this.acceptPolicy();
            });
        });
    }

    public static acceptPolicy(): void {
        const lang = $('html').prop('lang');

        $.post('/' + lang + CookiesView.url_accept, {accept: true}, (data) => {
            if (data.success) {
                (<any> $).fancybox({
                    href: '/' + lang + CookiesView.url_accept_body
                });
            } else {
                alert('Wystąpił błąd przy wysyłaniu akceptacji.');
            }
        });
    }
}
